import API from "./api";

export const getCheckoutData = async (reservationId) => {
  const res = await API.get(`/checkout/${reservationId}`);
  return res.data;
};

export const confirmCheckout = async (reservationId, data) => {
  const res = await API.post(`/checkout/${reservationId}/confirm`, data);
  return res.data;
};

export const getPublicTrailerCheckout = async (qrToken) => {
  const res = await API.get(`/public/trailer-checkout/${qrToken}`);
  return res.data;
};

export const confirmPublicTrailerCheckout = async (qrToken, data) => {
  const res = await API.post(`/public/trailer-checkout/${qrToken}/confirm`, data);
  return res.data;
};

export const verifyPublicTrailerCheckout = async (qrToken, data) => {
  const res = await API.post(`/public/trailer-checkout/${qrToken}/verify`, data);
  return res.data;
};
